import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, palette, spacing }) => ({
  container: {
    display: 'flex',
    minHeight: '70vh',
    margin: spacing(4),
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  containerContent: {
    [breakpoints.up('md')]: {
      width: '448px'
    },
    [breakpoints.down('md')]: {
      width: '100%'
    }
  },
  line: {
    display: 'flex',
    justifyContent: 'center',
    '& .MuiGrid-item': {
      with: '100%'
    },
    '& .MuiDivider-root': {
      width: '70%'
    }
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: '700',
    margin: spacing(3, 0),
    gap: spacing(1),
    '& .MuiSvgIcon-root': {
      color: 'rgba(29, 185, 84, 1)'
    }
  },
  subtitle: {
    [breakpoints.up('md')]: {
      margin: spacing(0, 8, 4, 8)
    },
    [breakpoints.down('md')]: {
      margin: spacing(0, 0, 4, 0)
    },
    textAlign: 'center',
    color: '#4A4C50'
  },

  subtitle2: {
    textAlign: 'center',
    color: '#4A4C50',
    marginBottom: spacing(2)
  },
  description: {
    textAlign: 'center',
    color: '#4A4C50',
    fontWeight: 'bold',
    // capitalize first letter using Material UI classes.
    '&:first-letter': {
      textTransform: 'capitalize'
    }
  },
  btn: {
    backgroundColor: palette.grey.shade[80],
    padding: '12px 16px',
    color: palette.common.white,
    '&:hover': {
      backgroundColor: palette.grey.shade[90],
      color: palette.common.white
    }
  },
  loadingIcon: {
    position: 'absolute',
    right: spacing(3)
  },
  button: {
    backgroundColor: palette.accent.main,
    color: palette.white.main,
    '&:hover': {
      backgroundColor: palette.accent.dark
    }
  },
  illustration: {
    display: 'flex',
    justifyContent: 'center',
    marginY: spacing(4)
  }
}))
